import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {
  MFAContainer,
} from "../../../styled";
import {show as showToast} from "../../../../actions/toastActions";
import {MAX_CODE_LENGTH} from "../../../constants";
import {segToHours} from "../../../../utils/date";
import {Form, Header, Icon} from "semantic-ui-react";
import {ClickableText, CustomContainer, CustomDivider, CustomGrid} from "../../../../components/custom-common";

const VerifyRenderItem = ({
  code,
  isDisabled,
  codeHandler,
  validateMfaCodeError,
  isCodeEmailVerified,
  validateForm,
  validationErrors,
  hasReachedMaxCodeRequests
}) => {
  return (
    <>
      <Form.Field className={'mfaVerifyCode'}>
        <Form.Input
          label={"6-digit authentication code"}
          type="text"
          name="emailCode"
          id="emailCode"
          value={code}
          onChange={(e) => codeHandler(e)}
          maxLength={MAX_CODE_LENGTH}
          error={!!validateMfaCodeError || validationErrors}
          required
          disabled={isDisabled || isCodeEmailVerified || hasReachedMaxCodeRequests}
          onBlur={(e) => validateForm(code)}
          className={'noVerticalMargin'}
        />

        {(validateMfaCodeError && !validationErrors) &&
          <p className={'warningRedText smaller'}>
            {validateMfaCodeError}
          </p>
        }

        {validationErrors && (
          <p className={'warningRedText smaller'}>
            Enter a 6-digit authentication code
          </p>
        )}

      </Form.Field>

        {isCodeEmailVerified &&
          (
             <p className="mfaVerified small">
               <Icon name="checkmark" size="small" className="verifiedIcon"/>
               Verified
             </p>
          )
        }
    </>
  );
};

const EmailVerify = ({
   codeHandler,
   validationErrors,
   code,
   validateMfaCodeError,
   loading,
   mfaEnabled,
   changeMethodSettings,
   validateForm,
   sendCodeByEmailHandler,
   goBackStepOne,
   hasReachedMaxCodeRequests,
   isCodeEmailVerified,
   remainingCodeResendWindowSeconds,
   remainingLockedOutTimeWindowSeconds,
   mfaEmailSetUpped
 }) => {
  const dispatch = useDispatch();
  const [counterSendEmail, setCounterSendEmail] = useState(remainingCodeResendWindowSeconds);
  const [runTime, setRunTime] = useState(false);

  const wrappSendCodeByEmailHandler = async () => {
    if (runTime || isCodeEmailVerified || hasReachedMaxCodeRequests) return

    await sendCodeByEmailHandler()
    dispatch(showToast({
      type: "success",
      title: "Email sent successfully",
      message: "A 6-digit code was sent for two-factor authentication.",
    }));
    setRunTime(true)
  }

  useEffect(() => {
    if(runTime) {
      setCounterSendEmail(remainingCodeResendWindowSeconds);
      setCounterSendEmail((time) => time - 1 );

      const interval = setInterval(() => {
        setCounterSendEmail((time) => time - 1 );
      }, 1000);

      return () => {
        clearInterval(interval);
      }
    }
  }, [runTime, remainingCodeResendWindowSeconds])

  useEffect(() => {
    if(counterSendEmail === 0) {
      setRunTime(false)
    }
  }, [counterSendEmail]);

  useEffect(() => {
    setRunTime(true)
  }, []);

    return (
        <>
          <MFAContainer className="sectionWrapper" maxWidth={"620px"}>
            <CustomGrid>
              <CustomGrid.Row>
                <CustomGrid.Column>
                  <Header as="h2" className={'noVerticalMargin'}>Enter authentication code</Header>
                  <CustomDivider smaller hidden/>
                  <div className={'neutral700Text'}>
                    Please enter the 6-digit code we sent you to {mfaEmailSetUpped} to verify setup below—
                  </div>
                </CustomGrid.Column>
              </CustomGrid.Row>
              <CustomGrid.Row fitted={'vertically'}>
                <CustomGrid.Column>
                  <Form>
                    <Form.Group grouped>
                            {!changeMethodSettings && (
                              <VerifyRenderItem
                                code={code}
                                validationErrors={validationErrors}
                                isDisabled={mfaEnabled}
                                loading={loading}
                                codeHandler={codeHandler}
                                validateForm={validateForm}
                                validateMfaCodeError={validateMfaCodeError}
                                isCodeEmailVerified={isCodeEmailVerified}
                                hasReachedMaxCodeRequests={hasReachedMaxCodeRequests}
                              />
                            )}

                            {hasReachedMaxCodeRequests && (
                              <CustomContainer basic className={'mfaMaxRequestsWarning'}>
                                <strong>You have reached the maximum number of code requests.</strong> <br/>
                                Please try again in {segToHours(remainingLockedOutTimeWindowSeconds)} hours or try a different authentication method.
                              </CustomContainer>
                            )}
                            <CustomDivider small hidden/>
                            <div className={'small neutral700Text'}>
                              <i>If you haven’t received the email after a few minutes,
                                 please check your junk mail folder as it may have been
                                 mistaken for spam.</i>
                            </div>
                            <CustomDivider small hidden/>
                            <CustomDivider small hidden/>

                            <div className={'neutral700Text small noVerticalMargin'}>
                              Didn’t receive the code?&nbsp;
                              <ClickableText
                                onClick={wrappSendCodeByEmailHandler}
                                disabled={runTime || isCodeEmailVerified || hasReachedMaxCodeRequests}
                              >
                                Resend {(runTime) && `in ${counterSendEmail}s`}
                              </ClickableText>
                            </div>
                            <CustomDivider small hidden/>
                            <CustomDivider small hidden/>
                            {!isCodeEmailVerified && (
                              <div className={'neutral700Text small'}>
                                Having trouble?&nbsp;
                                <ClickableText small onClick={goBackStepOne}>
                                  Try a different method
                                </ClickableText>
                              </div>
                            )}
                    </Form.Group>
                  </Form>
                </CustomGrid.Column>
              </CustomGrid.Row>
            </CustomGrid>

          </MFAContainer>
        </>
    )
}

export default EmailVerify
